/* eslint-disable import/prefer-default-export */
/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { initialState } from './slice';
//
const selectDomain = (state) => state[SLICE.ALERT] || initialState;
/**
 * Getting pace cumulative state for pace segment component
 */
export const selectLoader = createSelector([selectDomain], (state) => state?.loading);
/**
 * Getting pace cumulative state for pace segment component
 */
export const selectAlertData = createSelector([selectDomain], (state) => state?.alertData);
/**
 * Getting the filtered user by user id state into the component
 */
const getFirstParam = (_, param) => param;
export const selectAlertById = createSelector(
  [selectAlertData, getFirstParam],
  (alertData, alertId) => alertData?.results?.filter((alert) => alert?.id === alertId)[0]
);

/**
 * Getting alert parameter state into dashboard component
 */
export const selectAlertParam = createSelector([selectDomain], (state) => state.alertParams);
/**
 * Getting alert log data for the component
 */
export const selectAlertLogData = createSelector([selectDomain], (state) => state?.alertLogData);
/**
 * Getting alert log data for the component
 */
export const selectSubscriptionData = createSelector(
  [selectDomain],
  (state) => state?.subscriptionData
);
/**
 * Getting alert excel for the component
 */
export const selectAlertExcel = createSelector([selectDomain], (state) => state?.alertExcel);
/**
 * Getting alert remarks for the component
 */
export const selectAlertRemarks = createSelector([selectDomain], (state) => state?.alertRemarks);
/**
 * Getting semantic report data for PDF export for the component
 */
export const selectAlertPdf = createSelector([selectDomain], (state) => state?.alertPdf);
/**
 * Getting semantic PDF export failure state for the component
 */
export const selectAlertPdfError = createSelector([selectDomain], (state) => state?.alertPdfError);
